import { useEffect, useState } from 'react';

export function preloadImage(src: string) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      resolve(img);
    };
    img.onerror = img.onabort = function () {
      reject(src);
    };
    img.src = src;
  });
}

export default function useImagePreloader(imageList: string[]) {
  const [imagesPreloaded, setImagesPreloaded] = useState<boolean>(false);

  useEffect(() => {
    let isCancelled = false;

    (async function () {
      if (isCancelled) {
        return;
      }

      const imagesPromiseList: Promise<any>[] = [];

      for (const i of imageList) {
        imagesPromiseList.push(preloadImage(i));
      }

      const promiseSettledResult = await Promise.allSettled(imagesPromiseList);
      const rejected = promiseSettledResult.find(
        promise => promise.status === 'rejected',
      );
      if (rejected) {
        console.error('Some images was not loaded: ', rejected);
      }

      if (isCancelled) {
        return;
      }

      setImagesPreloaded(true);
    })();

    return () => {
      isCancelled = true;
    };
  }, [imageList]);

  return { imagesPreloaded };
}
